import { Fragment, useContext, useEffect, useState } from 'react'
import classNames from 'classnames'
import { renderToString } from 'react-dom/server'
import { Visible } from '@leroy-merlin-br/backyard-react-ui'

import emitter from 'garden/src/js/utils/emitter'
import Alert from 'garden/src/js/components/alert'

import * as cartRepository from 'scripts/api/cart'

import { useResize } from 'reactUtils/hooks/use-resize'

import { getServiceListMiniCart } from 'checkout/services/api/cart'
import { getProductsServices } from 'checkout/components/Cart/Body/util'

import { HeaderContext } from '../../contexts/HeaderContext'
import { HybrisCart } from './components/HybrisCart'
import CartDrawer from './components/CartDrawer'
import * as S from './styled'

const showAlert = ({ title, error }) => {
  const Message = renderToString(
    <div>
      <S.Title>{title}</S.Title>
      <div>
        {error}
        <br />
      </div>
    </div>
  )

  return new Alert({
    textMessage: Message
  })
}

const CART_URL = `${window.env && window.env.baseHost}/carrinho`
const CART_DEFAULT_VALUE = {
  shippings: [],
  uniqueProductsCount: 0,
  total: 0.0,
  subTotal: 0.0,
  discountTotal: 0.0
}

const Cart = () => {
  const headerContext = useContext(HeaderContext)
  const [isMobile] = useResize(992)
  const [informationCart, setInformationCart] = useState(CART_DEFAULT_VALUE)
  const [cartProductsCount, setProductsCount] = useState(
    informationCart.uniqueProductsCount
  )

  const {
    userResources: { cartItems, context, region },
    assistedSalesLinks,
    toggleCartDrawer
  } = headerContext

  const openCart = async event => {
    if (informationCart.uniqueProductsCount !== 0) {
      event.preventDefault()

      try {
        const response = await cartRepository.getCart()
        const body = response.data

        const {
          uniqueProductsCount,
          total,
          subTotal,
          discountTotal,
          shippings,
          servicesSubTotal,
          services
        } = body

        const cart = {
          uniqueProductsCount,
          total,
          subTotal,
          discountTotal,
          shippings,
          servicesSubTotal,
          services
        }

        setInformationCart(cart)
        toggleCartDrawer()
      } catch (err) {
        showAlert({
          title: 'Ops!',
          error:
            'Tivemos algum problema para recuperar o seu carrinho, tente novamente!'
        })
      }
    }
  }

  const renderCartLink = () => {
    if (cartProductsCount) {
      return <S.CartCount>{cartProductsCount}</S.CartCount>
    }

    return null
  }

  useEffect(() => {
    emitter.on('cart:update', ({ count }) => {
      const cart = {
        ...informationCart,
        uniqueProductsCount: count
      }

      setInformationCart(cart)
    })
  }, [informationCart])

  useEffect(() => {
    emitter.on('cart:products-replace', cart => {
      if (cart) {
        setInformationCart(cart)
      }
    })
  }, [])

  useEffect(() => {
    emitter.on('cart:products-quantity', cart => {
      setProductsCount(cart.uniqueProductsCount)
    })
  }, [])

  useEffect(() => {
    setProductsCount(informationCart.uniqueProductsCount)
  }, [informationCart])

  useEffect(() => {
    if (
      cartItems &&
      informationCart &&
      cartItems !== informationCart.uniqueProductsCount
    ) {
      const cart = {
        ...informationCart,
        uniqueProductsCount: cartItems
      }

      setInformationCart(cart)
    }
  }, [cartItems, informationCart])

  if (!context) {
    return (
      <section className="cart">
        <S.CartLink>
          <i className="glyph glyph-cart" />
          <Visible giga tera>
            <S.DesktopComplement>Meu Carrinho</S.DesktopComplement>
          </Visible>
        </S.CartLink>
      </section>
    )
  }

  if (context === 'assisted-sale') {
    return <HybrisCart assistedSalesLinks={assistedSalesLinks} />
  }

  return (
    <Fragment>
      <section>
        <S.CartLink href={CART_URL} onClick={openCart} title="Meu carrinho">
          {renderCartLink()}
          <i className="glyph glyph-cart" />
          <Visible giga tera>
            <S.DesktopComplement>Meu Carrinho</S.DesktopComplement>
          </Visible>
        </S.CartLink>
      </section>
      <CartDrawer cart={informationCart} />
    </Fragment>
  )
}

export default Cart
